// extracted by mini-css-extract-plugin
export var scrollArea = "_qe-0";